import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed bottom-5 right-10 z-50 flex items-end flex-col transition-all"
}
const _hoisted_2 = { class: "mr-14 mb-3 w-[70%] bg-white rounded-md border overflow-hidden shadow-lg p-5 flex flex-col gap-3 transition-all" }
const _hoisted_3 = { class: "font-bold text-lg" }
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.showTips)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.text.title), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.text.subtitle), 1)
        ], 512), [
          [_vShow, _ctx.tip]
        ]),
        _createElementVNode("img", {
          class: "w-20 h-20 cursor-pointer hover:opacity-75 transition-all animate-bounce-short",
          src: require('@/assets/images/info-audio-quiz.svg'),
          onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.tip = true)),
          onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tip = false))
        }, null, 40, _hoisted_4)
      ]))
    : _createCommentVNode("", true)
}